<div class='checkout-processor-main' data-cy="checkout-processor-container">
   <mat-progress-spinner *ngIf="isLoading" style="margin-left: auto; margin-right: auto; position: relative; top: 50%; transform: translateY(-50%)" diameter="100" mode="indeterminate" data-cy="checkout-processor-loading-spinner"></mat-progress-spinner>
   <mat-grid-list *ngIf="!isLoading" cols="6" rowHeight="100%" style="height:100%;" data-cy="checkout-processor-grid">
    <mat-grid-tile colspan="2" data-cy="checkout-processor-list-tile">
      <mat-card appearance="outlined" style="width:100%; height: calc(100%); display: flex; flex-direction: column;" data-cy="checkout-processor-list-card">
        <span class="configuration-section-title" data-cy="checkout-processor-list-title">Check Out Processor</span>
        <div style="flex: 1; max-height: 100%; overflow-y: hidden;" data-cy="checkout-processor-selection-container">

          <mat-form-field style="width:100%; margin-top: 3px;" data-cy="checkout-processor-client-field">
            <mat-label data-cy="checkout-processor-client-label">Practice (Licensee)</mat-label>
            <mat-select [(value)]="selectedClient" (selectionChange)="onChangeClient($event)" data-cy="checkout-processor-client-select">
              <mat-option *ngFor="let client of clientList" [value]="client" data-cy="checkout-processor-client-option">
                {{client.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field style="width:100%" data-cy="checkout-processor-location-field">
            <mat-label data-cy="checkout-processor-location-label">Practice Locations</mat-label>
            <mat-select [(value)]="selectedLocation" (selectionChange)="onChangeLoc('')" data-cy="checkout-processor-location-select">
              <mat-option *ngFor="let loc of locationList" [value]="loc" data-cy="checkout-processor-location-option">
                {{loc.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </mat-card>
    </mat-grid-tile>
    <mat-grid-tile colspan="4" data-cy="checkout-processor-details-tile">
      <mat-card appearance="outlined" style="width:100%;height:100%" data-cy="checkout-processor-details-card">
        <mat-card-content data-cy="checkout-processor-details-content">
          <div style="max-width: 60%;" data-cy="checkout-processor-details-container">
            <app-tdo-configuration-action-bar [isCustom]="true" data-cy="checkout-processor-action-bar">
              <button mat-button class="tdo-button tdo-save" data-cy="checkout-processor-edit-btn">Edit</button>
              <button mat-button class="tdo-button tdo-save" (click)="SaveCheckOutProcedures()" data-cy="checkout-processor-save-btn">Save</button>
              <button mat-button class="tdo-button tdo-save" (click)="DefaultCheckOutProcedures()" data-cy="checkout-processor-default-btn">Default</button>
            </app-tdo-configuration-action-bar>
            <div style="display:flex; flex-direction: column; height: 850px;" data-cy="checkout-processor-form-container">
            <div style="display:flex; flex-direction: column; height: 75%; overflow: auto;" data-cy="checkout-processor-procedures-container">
            <form [formGroup]="myForm" data-cy="checkout-processor-form">
                <div formArrayName="checkOutProcedure" cdkDropList class="example-list" (cdkDropListDropped)="drop($event)" data-cy="checkout-processor-procedure-list">
                  <div *ngFor="let procedure of checkOutProcedureForms.controls; let i=index" [formGroupName]="i" class="row example-box" cdkDrag data-cy="checkout-processor-procedure-item">
                    <div class="col-md-1" style="align-content:center; vertical-align:bottom" data-cy="checkout-processor-procedure-number">
                      <h5>{{i + 1}}</h5>
                    </div>
                    <div class="col-md-9" data-cy="checkout-processor-procedure-dropdown-container">
                        <app-tdo-dropdown placeholder="Select check out procedure"
                                          [dataSource]="checkOutTasksEnumsReplacement"
                                          dataSourceDisplayKey="ItemDisplayValue"
                                          [isObjectValue]="true"
                                          [value]="selectedCheckOutTask[i]"
                                          (selectionChange)="onChangeCheckOutTask($event,i)"
                                          data-cy="checkout-processor-procedure-dropdown">
                        </app-tdo-dropdown>
                    </div>
                    <div class="col-md-1" data-cy="checkout-processor-procedure-delete-container">
                      <button mat-icon-button (click)="deleteProcedure(i)" data-cy="checkout-processor-procedure-delete-btn"><mat-icon>delete</mat-icon></button>
                      <!--<button style="flex: 1; cursor: pointer;" mat-icon-button (click)="deleteProcedure(i)"><mat-icon [style]="row.getActionStyle(action)">delete</mat-icon></button>!-->
                    </div>
                  </div>
                </div>
            </form>
          </div>
            <!--<div style="position: absolute; bottom: 10%;left: 1%">!-->
              <div style="display:flex; flex-direction: column; height: 25%; padding-top: 10px" data-cy="checkout-processor-add-container">
              <button mat-button class="tdo-button tdo-save" (click)="AddElement()" data-cy="checkout-processor-add-btn">Add</button></div>
          </div>
          </div>


        </mat-card-content>
      </mat-card>
    </mat-grid-tile>
  </mat-grid-list>
</div>



